module.exports = __webpack_public_path__ + "static/media/marketplace_logo.715fdb6b.png";